import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DELETEINCIDENTDATA } from '../common/constants/labels';
import { DeleteIncidentDataModel } from '../common/models/incident-dashboard-filterparameterdata';
import { Role } from '../common/models/role';
import { IncidentUploadSqlService } from '../incident-upload-SQL/incident-upload-sql.service';

@Component({
  selector: 'app-delete-incident-data',
  templateUrl: './delete-incident-data.component.html',
  styleUrls: ['./delete-incident-data.component.scss']
})
export class DeleteIncidentDataComponent implements OnInit {

  fileId: number;
  fileName: string;
  uploadedBy: string;
  uploadedDate: Date;
  noRecordsShow = false;
  showSuccess = false;
  showErrorMessage = false;
  recordDeleted: string;
  errorMsg: string;
  isMasterSel = false;
  dataSource = [];
  selectedData: number[];
  deleteParameter: DeleteIncidentDataModel;
  displayedColumns: any;
  role: string;
  loading = false;
  noRecords = '';

  constructor(private route: ActivatedRoute, private incidentservice: IncidentUploadSqlService, private router: Router) {
    // this.fileId = + this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      this.fileId = + params['id'];
    });
  }

  ngOnInit() {
    this.noRecordsShow = false;
    this.loading = true;
    this.displayedColumns = DELETEINCIDENTDATA;
    this.getIncidentData();
  }

  getIncidentData() {
    this.incidentservice.getIncidentDatabyFileId(this.fileId).subscribe((response) => {
      this.noRecordsShow = false;
      if (response.length > 0) {
        const incidentData = [];
        response.forEach((e) => {
          let object = {};
          object = {
            productiondate: e.productiondate,
            productcode: e.productcode,
            productdescription: e.productdescription,
            cluster: e.cluster,
            defectmodeaggregation: e.defectmodeaggregation,
            bigcategory: e.bigcategory,
            subcategory: e.subcategory,
            recordid: e.recordid,
            formatsize: e.formatsize,
            losstree: e.losstree,
            leveL0: e.leveL0,
            leveL1: e.leveL1,
            leveL2: e.leveL2,
            leveL3: e.leveL3,
            leveL4: e.leveL4,
            leveL5: e.leveL5,
            defectseveritygrade: e.defectseveritygrade,
            productionline: e.productionline,
            noofblockedproduct: e.noofblockedproduct,
            averagebatchqty: e.averagebatchqty,
            uom: e.uom,
            affectedproductpercentage: e.affectedproductpercentage,
            frequencyscore: e.frequencyscore,
            processpoint: e.processpoint,
            fourms: e.fourms,
            detectionpoint: e.detectionpoint,
            detectability: e.detectability,
            eincident: e.eincident,
            rework: e.rework,
            ambercrqs: e.ambercrqs,
            qualityrelatedwaste: e.qualityrelatedwaste,
            dincidents: e.dincidents,
            palletnonconformance: e.palletnonconformance,
            customernonconformance: e.customernonconformance,
            onshelfcrqs: e.onshelfcrqs,
            consumercomplaints: e.consumercomplaints,
            marketplaceincident: e.marketplaceincident,
            costof1pc: e.costof1pc,
            totaldefectcost: e.totaldefectcost,
            totalcostpercentage: e.totalcostpercentage,
            costscore: e.costscore,
            detectabilityindex: e.detectabilityindex,
            severityindex: e.severityindex,
            frequencyindex: e.frequencyindex,
            costindex: e.costindex,
            defectpriorityindex: e.defectpriorityindex,
            dpivstotaldpipercentage: e.dpivstotaldpipercentage,
            cummulativedpi: e.cummulativedpi,
            dpidefectclass: e.dpidefectclass,
            man: e.man,
            machine: e.machine,
            method: e.method,
            material: e.material,
            pdcastatus: e.pdcastatus,
            sites: e.sites,
            localcurrency: e.localcurrency,
            totaldefectcosteuro: e.totaldefectcosteuro,
            filenames: e.filenames,
            uploadedDate: e.uploadedDate,
            uploadedBy: e.uploadedBy,
            id: e.id,
            incidentfileid: e.incidentfileid,
            isselected: false
          };
          incidentData.push(object);
        });
        this.dataSource = incidentData;
        this.fileName = this.dataSource[0].filenames;
        this.uploadedBy = this.dataSource[0].uploadedBy;
        this.uploadedDate = this.dataSource[0].uploadedDate;
        this.loading = false;
      } else {
        this.noRecords = 'No Records available';
        this.noRecordsShow = true;
        this.loading = false;
      }
    }, (error) => {
      this.noRecordsShow = true;
      this.showSuccess = false;
      this.errorMsg = 'Failed to get the incident record.';
      this.showErrorMessage = true;
      this.loading = false;
    });
  }

  checkUncheckAll() {
    for (let i = 0; i < this.dataSource.length; i++) {
      this.dataSource[i].isselected = this.isMasterSel;
    }
    this.getCheckedItemList();
  }

  isAllSelected() {
    // this.isMasterSel = this.dataSource.every(function(item: any) {
    //     return item.isSelected === true;
    //   });
    this.isMasterSel = true;
    this.dataSource.forEach( item =>  {
      if (item.isselected === false) {
        this.isMasterSel = false;
      }
    });
    this.getCheckedItemList();
  }
  getCheckedItemList() {
    this.selectedData = [];
    for (let i = 0; i < this.dataSource.length; i++) {
      if (this.dataSource[i].isselected) {
        this.selectedData.push(this.dataSource[i].id);
      }
    }
  }

  deleteData() {
    this.loading = true;
    this.deleteParameter = {
      Id: this.selectedData,
      fileName: this.dataSource[0].filenames
    };
    this.incidentservice.deleteIncidentDatas(this.deleteParameter).subscribe((response) => {
      this.showSuccess = true;
      this.recordDeleted = 'Number of records deleted : ' + response.deletedRecordCount;
      this.getIncidentData();
    }, (error) => {
      this.showSuccess = false;
      this.errorMsg = 'Failed to delete the selected record.';
      this.showErrorMessage = true;
      this.loading = false;
    });
  }

  loadDataUploadPage() {
    this.router.navigate(['/filesSQL']);
  }

    // Authorization
    get isAuthorized() {
      this.role = localStorage.getItem('role');
      if (this.role === Role.qualityManager || this.role === Role.qualityEngineer || this.role === Role.globalAdmin || this.role === Role.ITSupport) {
        return true;
      } else {
        return false;
      }
    }

}
